export const menuEn = {
  hero: {
    title: 'Our Menu',
    subtitle: 'Authentic Neapolitan cuisine made with love and tradition',
  },
  allergyNote: 'Please inform your server of any allergies or dietary requirements.',
  bookTable: 'Book a Table',
  legend: {
    vegetarian: 'Vegetarian',
    spicy: 'Spicy',
    special: "Chef's Special",
    recommended: 'Recommended dishes',
  },
  categories: {
    antipasti: 'Starters',
    zuppe: 'Soup',
    risotto: 'Risotto',
    insalate: 'Salads',
    bambini: 'For children (12 years old and younger)',
    pasta: 'Pasta',
    pesce: 'Fish',
    carne: 'Meat',
    pizze: 'Pizza',
    desserts: 'Desserts',
  },
  items: {
    1: {
      name: 'Bruschetta Pomodoro e aglietto',
      description:
        'Char grilled homemade bread topped with fresh vine tomatoes, garlic, basil, oregano and extra virgin olive oil.',
    },
    2: {
      name: 'Bruschetta Salmone',
      description:
        'Char grilled homemade bread topped with salad, smoked salmon and honey mustard dressing.',
    },
    3: {
      name: 'Bruschetta Caprese',
      description: 'Char grilled homemade bread topped with fresh mozzarella, tomatoes and basil',
    },
    4: {
      name: 'Bruschetta Mix for 2',
      description: 'For 2 to share - mixed bruschetta',
    },
    5: {
      name: 'Bruschetta Mix for 4',
      description: 'For 4 to share - mixed bruschetta',
    },
    6: {
      name: 'Pane All´Aglio',
      description: 'Wood-oven baked garlic bread with mozzarella',
    },
    7: {
      name: 'Calamari Fritti',
      description: 'Deep fried Calamari with lemon and garlic mayonnaise',
    },
    8: {
      name: 'Carpaccio',
      description: 'Thin sliced beef with olive oil, rucola, parmesan and lemon.',
    },
    9: {
      name: 'Gamberoni alla "Zio Pepper"',
      description: 'Pan-fried Tiger shrimp with spicy garlic buttersauce.',
    },
    10: {
      name: 'Zuppa del giorno',
      description: 'Soup of the day (Please ask our waiter)',
    },
    11: {
      name: 'Zuppa di frutti di mare',
      description: 'Creamy seafood soup with mussels, shrimps and scallops.',
    },
    12: {
      name: 'Risotto ai Funghi',
      description: 'Risotto with wild mushrooms and chicken',
    },
    13: {
      name: 'Risotto del Pescatore',
      description: 'Risotto with seafood & creamy saffran, mussels scallops and king prawns.',
    },
    14: {
      name: 'Rocket salat',
      description:
        'Rocket salad, yellow and red Datterin tomatoes, parmesan cheese, olive oil and balsamic.',
    },
    15: {
      name: 'Caprese',
      description: 'Fresh mozzarella, tomatoes, origano, basil & olive oil',
    },
    16: {
      name: 'RossoPomodoro',
      description: 'Mixed salad with parma ham, tomatoes, egg, olives & parmesan cheese',
    },
    17: {
      name: 'Insalata alla cesare',
      description: 'Cesar salad with grilled chicken, crostini, bacon and parmesan cheese',
    },
    18: {
      name: 'Insalata mista',
      description: 'Side salad (green salad & tomatoes)',
    },
    19: {
      name: 'Lasagne',
      description: 'Meat Lasagne',
    },
    20: {
      name: 'Spaghetti Bolognese',
      description: 'Spaghetti Bolognese',
    },
    21: {
      name: 'Penne pasta',
      description: 'Penne in tomato sauce',
    },
    22: {
      name: 'Chicken breast',
      description: 'Chicken breast with chips',
    },
    23: {
      name: 'Pizza Margherita',
      description: 'Pizza Margherita',
    },
    24: {
      name: 'Pizza with ham',
      description: 'Pizza with ham and cheese',
    },
    25: {
      name: 'Pizza with chocolate',
      description: 'Pizza with Nutella',
    },
    26: {
      name: 'Penne con Pancetta e Pollo',
      description: 'Penne pasta with roasted chicken & bacon in a rosemary tomato sauce',
    },
    27: {
      name: 'Penne all´Arrabiata',
      description: 'Penne pasta with chilli tomato sauce.',
    },
    28: {
      name: 'Penne Prosciutto e Panna',
      description: 'Penne pasta with ham & mushrooms, in a creamy cheese sauce.',
    },
    29: {
      name: 'Lasagne di Carne',
      description: 'Lasagne layered with bolognese and bechamel sauce.',
    },
    30: {
      name: 'Spaghetti alla Carbonara',
      description: 'Spaghetti carbonara with bacon, cream, eggs and black pepper.',
    },
    31: {
      name: 'Spaghetti Aglio Olio e Pomodorini',
      description:
        'Spaghetti with freshly chopped garlic, olive oil, red chilli, parsley and cherry tomatoes',
    },
    32: {
      name: 'Spaghetti Bolognese',
      description: 'Spaghetti with bolognese sauce.',
    },
    33: {
      name: 'Cannelloni con Spinaci e Ricotta',
      description: 'Roll pasta filled with ricotta cheese and spinach.',
    },
    34: {
      name: 'Ravioli ai Funghi',
      description: 'Ravioli stuffed with ricotta and spinach in creamy mushroom sauce.',
    },
    35: {
      name: 'Linguine ai Gamberoni',
      description: 'Linguine with tiger prawns in creamy chilli sauce.',
    },
    36: {
      name: 'Linguine allo Scoglio',
      description:
        'Tagliatelle with squid, mussels, scallops and king prawns in a whitewine and cherry tomato sauce.',
    },
    37: {
      name: 'Spaghetti con Polpette',
      description: 'Spaghetti with meatballs just like grandma used to make.',
    },
    38: {
      name: 'Catch of the day',
      description: 'Catch of the day (Please ask our waiter)',
    },
    39: {
      name: 'Salmone al forno con aneto e Pernod',
      description:
        'Oven baked salmon with dill and Pernod sauce, served with potatoes and vegetables.',
    },
    40: {
      name: 'Milanese di Maiele',
      description:
        'Wienerschnitzel served with creamy wild mushroom sauce, potatoes and vegetables',
    },
    41: {
      name: 'Petto di Pollo',
      description:
        'Grilled chicken breast stuffed with Parma ham & mozzarella cheese, and red wine sauce with potatoes.',
    },
    42: {
      name: 'Agnello al Rosmariono',
      description: 'Grilled fillet of lamb with baked potato, vegetables and creamy mushroom sauce',
    },
    43: {
      name: 'Filetto di Manzo al Pepe',
      description: 'Grilled beef tenderloin with baked potato and green pepper sauce',
    },
    44: {
      name: 'Filetto di manzo al funghi',
      description: 'Grilled beef tenderloin with baked potato and a creamy mushroom sauce',
    },
    45: {
      name: 'Margherita',
      description: 'Tomato sauce, mozzarella and basil',
    },
    46: {
      name: 'Napoli',
      description: 'Tomato sauce, cheese, oregano, anchovies, garlic and olives',
    },
    47: {
      name: 'Ventura',
      description: 'Mozzarella, Parma ham, rocket salad, shavings of parmesan',
    },
    48: {
      name: 'Rustica',
      description: 'Tomato sauce, mozzarella, ham and mushrooms',
    },
    49: {
      name: 'Tonno e Cipolla',
      description: 'Tomato sauce, mozzarella, tuna and onion',
    },
    50: {
      name: 'Sorrentina',
      description: 'Tomato sauce, mozzarella and pepperoni',
    },
    51: {
      name: 'Formaggi',
      description: 'Mozzarella, ricotta, bufala, camembert and gorgonzola cheese',
    },
    52: {
      name: 'Calzone',
      description: 'Calzone with tomato, mozzarella, mushrooms & ham',
    },
    53: {
      name: 'Capricciosa',
      description: 'Tomato, mozzarella, ham, mushrooms, olives and artichokes.',
    },
    54: {
      name: 'Corbarella',
      description: 'Mozzarella, cream, ham, mushrooms and black pepper.',
    },
    55: {
      name: 'Vegeteriana',
      description: 'Tomato, mozzarella & roasted vegetables, mushrooms.',
    },
    56: {
      name: 'Verace',
      description: 'Tomato, buffalo mozzarella and basil',
    },
    57: {
      name: 'Marinarella',
      description: 'Tomato, mozzarella, garlic, mussels, squid, prawns & scallops',
    },
    58: {
      name: 'Hawaian',
      description: 'Tomato, mozzarella, ham and pineapple',
    },
    59: {
      name: 'Verona',
      description: 'Tomato, mozzarella, pepperoni, onion & cream cheese',
    },
    60: {
      name: 'Pizzaiolo',
      description: 'With pepperoni, jalapeño, minced meat and garlic.',
    },
    61: {
      name: 'Pizza del Piazzaiolo',
      description:
        "The chef's favorite, with fresh mozzarella, ham, pepperoni, pepper cheese and bacon.",
    },
    62: {
      name: 'Salmone',
      description: 'Mozzarella, cream cheese, smoked salmon and rocket salad.',
    },
    63: {
      name: 'Tíramisú',
      description: 'Traditional Italian dessert.',
    },
    64: {
      name: 'Nero Mangiare',
      description: 'Hot chocolate soufflé with vanilla ice cream.',
    },
    65: {
      name: "'O Gelato",
      description: 'Mixed ice cream.',
    },
    66: {
      name: 'Brulée',
      description: 'Crème brûlée.',
    },
    67: {
      name: "'A Torta",
      description: 'Hot apple pie with ice cream and whipped cream.',
    },
  },
};
